// extracted by mini-css-extract-plugin
module.exports = {"WizardFormConfigurationStep2RegionLabel":"WizardFormConfigurationStep2RegionLabel_6PbvW"};